export const IOS_STORE_URL =
  'https://apps.apple.com/fr/app/pikkopay/id6745275234?utm_source=sms&utm_medium=deep_link&utm_campaign=cagnotte_5e';
export const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=fr.pikkopay.app&utm_source=sms&utm_medium=deep_link&utm_campaign=cagnotte_5e';
